import { render, staticRenderFns } from "./WeatherBoard.vue?vue&type=template&id=1c14a210&scoped=true&"
import script from "./WeatherBoard.vue?vue&type=script&lang=js&"
export * from "./WeatherBoard.vue?vue&type=script&lang=js&"
import style0 from "./WeatherBoard.vue?vue&type=style&index=0&id=1c14a210&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c14a210",
  null
  
)

export default component.exports